import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext'; // Import the useUser hook
import Powered_by_logo from "../assets/images/Powered_by_logo.png";
import UAVSphere_logo from  "../assets/images/UAVspherelogo.png";

const LandingPage = () => {
    const { userType, setUserType } = useUser(); // Access userType and setUserType from context
    const navigate = useNavigate();

    const handleSelectUserType = (type) => {
        setUserType(type); // Correctly set the user type
        navigate(type === 'provider' ? '/account/login?role=provider' : '/map'); // Navigate based on user type
    };

    useEffect(() => {
    }, [userType]); // Dependency array to run when userType changes

    return (
        <div className="container text-center mt-5">
            <h1>Welcome </h1>
            <h2> to </h2>
            <img 
                src={UAVSphere_logo} 
                alt="UAVSphere Logo" 
                style={{ width: '200px', height: 'auto', marginLeft: '5px' }} 
            />
           <div className="mt-3">
                <p className="mb-1">Powered by GeoWGS84 <br/>
                    <a href="https://www.geowgs84.com/" target="_blank" rel="noopener noreferrer">
                        <img 
                            src={Powered_by_logo} 
                            alt="Company Logo" 
                            style={{ width: '30px', height: 'auto', marginLeft: '5px' }} 
                        />
                    </a>
                </p>
            </div>            
            <br/>
            <h4>Choose your role to continue</h4> <br/>
            <div>
                <button
                    className="btn btn-secondary ms-3"
                    onClick={() => handleSelectUserType('customer')}
                >
                    Are you a drone customer?
                </button>
                
                <button
                    className="btn btn-primary ms-3"
                    onClick={() => handleSelectUserType('provider')}
                >
                    Are you a drone provider?
                </button>
            </div>
        </div>
    );
};

export default LandingPage;
